import { SVGProps } from 'react';

export const TextIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3.28572V2H8.14286H6.85714H3V3.28571V4.57143H4.28571V3.28571L6.85714 3.28571V12.2857H5.57143V13.5714L6.85714 13.5714H8.14286L9.42857 13.5714V12.2857H8.14286V3.28571L10.7143 3.28571V4.57143H12V3.28572Z'
    />
  </svg>
);
